// Shared motion tokens: every animation in the app picks from these, so they all feel like one system.
// Keep UI motion under ~250ms; data reveals and the nav hover wave run longer but never block input.
export const DURATION = {
	fast: 0.12,
	base: 0.18,
	slow: 0.24,
	reveal: 1,
	wave: 0.45
};

export const EASE = {
	out: [0.22, 1, 0.36, 1],
	inOut: [0.65, 0, 0.35, 1],
	// Data reveals (counters, donut sweep, sparkline): one curve, so they all move in step.
	reveal: [0.4, 0, 0.2, 1]
};

// A curve as a CSS / Recharts easing string.
export const cubicBezier = (curve) => `cubic-bezier(${curve.join(', ')})`;

export const SPRING = {
	// Position changes (the sliding nav pill): settles fast, no visible bounce.
	snappy: { type: 'spring', stiffness: 520, damping: 42, mass: 0.8 }
};

// Seconds between siblings in a staggered entrance.
export const STAGGER_DELAY = 0.04;
